import LanguageSetting from './LanguageSetting';
import DeleteIcon from '@mui/icons-material/Delete';
import LogoutIcon from '@mui/icons-material/Logout';
import SuperviseModeToggle from './SuperviseModeToggle';
import NotificationToggle from './NotificationToggle';
import TimerToggle from './TimerToggle';
import DarkModeToggle from './DarkModeToggle';
import ManageSupervisorsSetting from './ManageSupervisorsSetting';
import ManageClientsSetting from './ManageClientsSetting';
import LegalSetting from './LegalSetting';
import { BasicDialogContent } from '../utils/dialogs/BasicDialog';
import AISettings from './AISettings';
import ProfileSettings from './ProfileSettings';
import { useTheme } from '@mui/material/styles';
import { AccordionSummary, Box, Stack, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { t } from 'i18next';

export type SettingsConfig = {
  id: string;
  title: string;
  titleColor?: string;
  accordionContent?: () => JSX.Element;
  icon?: () => JSX.Element;
  hideAsSupervisor?: boolean;
  onlyAsSupervisor?: boolean;
  dialog?: BasicDialogContent;
  accordionHeader?: (props: SettingsConfig) => JSX.Element;
  toggleComponent?: (props: SettingsConfig) => JSX.Element;
  disabled?: boolean;
};

const DeleteAccountHeader = (props: SettingsConfig) => {
  const theme = useTheme();
  const deleteColor = theme.palette.mode === 'light' ? red[700] : theme.palette.error.light;

  return (
    <AccordionSummary>
      <Stack
        justifyContent={'space-between'}
        direction={'row'}
        width={'100%'}
        alignItems={'center'}
      >
        <Typography variant="h6" sx={{ color: deleteColor }}>
          {t(props.title)}
        </Typography>
        <DeleteIcon sx={{ color: deleteColor }} />
      </Stack>
    </AccordionSummary>
  );
};

export const settingsConfig: SettingsConfig[] = [
  {
    id: 'supervise',
    title: 'Supervise mode',
    toggleComponent: SuperviseModeToggle, // Using the toggleComponent property instead of accordionHeader
  },
  {
    id: 'notificationToggle',
    title: 'Notifications',
    toggleComponent: NotificationToggle, // Change this from accordionHeader
  },
  {
    id: 'darkMode',
    title: 'Dark mode',
    toggleComponent: DarkModeToggle, // Change this from accordionHeader
  },
  {
    id: 'timerToggle',
    title: 'View timer in clock view',
    toggleComponent: TimerToggle, // Change this from accordionHeader
  },
  {
    id: 'profile',
    title: 'Profile',
    accordionContent: ProfileSettings,
    hideAsSupervisor: true,
  },
  {
    id: 'AISettings',
    title: 'AI Settings',
    accordionContent: AISettings,
    hideAsSupervisor: true,
  },
  {
    id: 'supervisorManagement',
    title: 'Manage supervisors',
    accordionContent: ManageSupervisorsSetting,
    hideAsSupervisor: true,
  },
  {
    id: 'clientManagement',
    title: 'Manage clients',
    accordionContent: ManageClientsSetting,
    onlyAsSupervisor: true,
  },
  {
    id: 'language',
    title: 'Language',
    accordionContent: LanguageSetting,
  },
  {
    id: 'PrivacyPolicyAndTermsOfService',
    title: 'Legal & Licenses',
    accordionContent: LegalSetting,
  },
  {
    id: 'deleteAccount',
    title: 'Delete account',
    accordionHeader: DeleteAccountHeader,
    dialog: {
      title: 'Delete account',
      body: 'Are you sure you want to delete your account?',
      confirmText: 'Yes',
      cancelText: 'No',
      confirmButtonColor: 'error',
    },
  },
  {
    id: 'logout',
    title: 'Logout',
    icon: () => <LogoutIcon />,
    dialog: {
      title: 'Logout',
      body: 'Are you sure you want to logout?',
      confirmText: 'Logout',
      cancelText: 'No',
    },
  },
];
